import React, { useEffect } from 'react';

import { useInView } from 'react-intersection-observer';

import { useAppSelector, useGetGroupsFollowing, useNavigateTop } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { GROUP_BASE } from '@app/routes/paths/groups';

import { GroupsNavigationDesktop, GroupsNavigationMobile } from './components';
import { GroupItemSkeletonMobile } from './components/GroupsNavigationMobile/styles';
import { GroupItemAvatarSkeleton } from './components/styles';

export const GroupsNavigation = () => {
    const { tablet } = useMediaQuery();
    const { isLoading, data: groupsPageData, isFetching, fetchNextPage, hasNextPage } = useGetGroupsFollowing();

    const currentUserId = useAppSelector((state) => state.user?.userAccount?.user.id);
    const navigate = useNavigateTop();
    const { ref, inView } = useInView();

    useEffect(() => {
        if (inView && !isLoading && !isFetching) {
            fetchNextPage();
        }
    }, [fetchNextPage, inView, isFetching, isLoading]);

    const handleItemClick = (slug: string) => {
        navigate(`${GROUP_BASE}/${slug}`);
    };

    const groupsData = groupsPageData?.pages.map((page) => page.data).flat();

    const loadMoreItemMarkupDesktop = !isLoading && hasNextPage && (
        <GroupItemAvatarSkeleton ref={ref} $loading key={`podnav-skeleton-loading`} />
    );

    const loadMoreItemMarkupMobile = !isLoading && hasNextPage && (
        <GroupItemSkeletonMobile ref={ref}>
            <GroupItemAvatarSkeleton $loading />
        </GroupItemSkeletonMobile>
    );

    if (tablet)
        return (
            <GroupsNavigationDesktop
                currentUserId={currentUserId}
                groupsData={groupsData}
                handleItemClick={handleItemClick}
                isLoading={isLoading}
                loadMoreItem={loadMoreItemMarkupDesktop}
            />
        );

    return (
        <GroupsNavigationMobile
            currentUserId={currentUserId}
            groupsData={groupsData}
            handleItemClick={handleItemClick}
            isLoading={isLoading}
            loadMoreItem={loadMoreItemMarkupMobile}
        />
    );
};
